import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface CeilingsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Ceilings: React.FC<CeilingsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [ceilings, setCeilings] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Ceilings'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Ceilings: v } } })
    );
    const label = 'Ceilings';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={ceilings}
                />
            ) : (
                <TextBox
                    value={ceilings ?? ''}
                    onChange={(value) => setCeilings(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
